import { render } from "./CgRecordDetail.vue?vue&type=template&id=a67ff9b6&scoped=true"
import script from "./CgRecordDetail.vue?vue&type=script&lang=js"
export * from "./CgRecordDetail.vue?vue&type=script&lang=js"

import "./CgRecordDetail.vue?vue&type=style&index=0&id=a67ff9b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67ff9b6"]])

export default __exports__